import React from "react";
import { Search, RotateCw } from "lucide-react";

const VENUE_OPTIONS = [
  { id: "center", label: "Trung tâm" },
  { id: "school", label: "Tại trường" },
  { id: "all", label: "Tất cả" },
];

const inputClass =
  "bg-white border border-gray-200 rounded-xl md:rounded-lg text-base md:text-sm font-semibold text-gray-700 outline-none transition-all focus:border-red-500 focus:ring-2 focus:ring-red-500/10 min-h-[44px] md:min-h-0";

/**
 * Thanh lọc tab "Điểm danh hàng ngày" — file UI riêng.
 */
const AttendanceDailyFilter = ({
  selectedDate,
  onDateChange,
  searchTerm,
  onSearchChange,
  isMobile,
  onRefresh,
  venue = "center",
  onVenueChange,
  canFilterAllBranches = false,
  branchId = "all",
  branches = [],
  onBranchChange,
}) => {
  const venueVal = venue || "center";

  return (
    <div
      className={`bg-white rounded-xl border border-gray-100 shadow-sm ${
        isMobile ? "p-3 space-y-2.5" : "p-4"
      }`}
      data-tour="attendance-filter"
    >
      <div
        className={`${
          isMobile ? "pb-2.5 border-b border-gray-100" : "pb-3 mb-3 border-b border-gray-100"
        }`}
      >
        {!isMobile ? (
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-2">
            Địa điểm lớp
          </span>
        ) : null}
        <div
          className={
            isMobile
              ? "grid grid-cols-3 gap-1"
              : "flex flex-wrap gap-1.5"
          }
        >
          {VENUE_OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              onClick={() => onVenueChange?.(opt.id)}
              className={`${
                isMobile ? "min-h-[40px] w-full" : "px-3 py-1.5"
              } rounded-lg text-[10px] font-bold uppercase tracking-wide transition-all touch-manipulation ${
                venueVal === opt.id
                  ? "bg-red-600 text-white shadow-sm"
                  : "bg-gray-100 text-gray-600 active:bg-gray-200 hover:bg-gray-200"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {canFilterAllBranches && branches.length > 0 && (
        <div
          className={`${isMobile ? "pb-2.5" : "pb-3 mb-1"} flex flex-col sm:flex-row sm:items-center gap-2`}
        >
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider shrink-0">
            Chi nhánh
          </label>
          <select
            value={branchId}
            onChange={(e) => onBranchChange?.(e.target.value)}
            className={`w-full sm:max-w-xs px-3 py-2 ${inputClass}`}
          >
            <option value="all">Tất cả chi nhánh</option>
            {branches.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className={`flex ${isMobile ? "flex-col gap-2" : "flex-wrap items-center gap-2.5"}`}>
        <div className={`flex gap-2 ${isMobile ? "w-full" : ""}`}>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
            className={`${isMobile ? "flex-1" : "w-auto shrink-0"} px-3 py-2 ${inputClass}`}
          />
          <button
            type="button"
            onClick={() => onRefresh?.()}
            className="h-11 w-11 md:h-9 md:w-9 flex items-center justify-center rounded-xl md:rounded-lg border border-gray-200 bg-white text-gray-500 active:text-red-500 active:border-red-200 transition-all shrink-0 touch-manipulation"
            title="Làm mới danh sách"
          >
            <RotateCw size={16} />
          </button>
        </div>

        <div className={`relative group ${isMobile ? "w-full" : "w-full max-w-sm"}`}>
          <Search
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-red-500 transition-colors"
            size={16}
          />
          <input
            type="search"
            enterKeyHint="search"
            placeholder={isMobile ? "Tìm lớp..." : "Tìm nhanh lớp học..."}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className={`w-full pl-10 pr-3 py-2 ${inputClass}`}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceDailyFilter;
